import { ArrowRight, Download } from "lucide-react";

export default function Hero({ onBook, onCapability }) {
    return (
        <section
            id="hero"
            className="relative pt-28 sm:pt-32 lg:pt-36 pb-20 sm:pb-28 overflow-hidden hero-grid"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="reveal max-w-5xl">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 text-[11px] uppercase tracking-widest text-zinc-300 mb-6">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#1FA8FF] live-dot" />
                        Tier 1 compliance, AI automated
                    </div>

                    <h1 className="font-display text-[34px] leading-[1.02] sm:text-5xl sm:leading-[1.0] lg:text-6xl lg:leading-[1.0] xl:text-[68px] xl:leading-[1.0] text-white">
                        Next generation Tier 1 AI Contractor Compliance
                    </h1>

                    <p className="mt-6 font-display text-2xl sm:text-3xl lg:text-4xl text-zinc-200 max-w-3xl leading-tight tracking-wide">
                        Built AI-native. Built in Australia. Built for the
                        principals who set the standard.
                    </p>

                    <p className="mt-5 text-lg sm:text-xl text-zinc-400 max-w-3xl leading-relaxed">
                        Be the principal that nothing happens on. The one whose
                        projects finish on time, on budget, and without the call
                        no one wants to take.
                    </p>

                    <div className="mt-8 flex flex-col sm:flex-row gap-3">
                        <button
                            onClick={onBook}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-[#1FA8FF] text-white font-semibold hover:bg-[#0C84D4] transition-colors"
                            data-testid="hero-book-demo"
                        >
                            Book a demo
                            <ArrowRight className="w-4 h-4" />
                        </button>
                        <button
                            onClick={onCapability}
                            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg border border-white/25 text-white font-semibold hover:bg-white/5 transition-colors"
                            data-testid="hero-capability"
                        >
                            <Download className="w-4 h-4" />
                            Download capability statement
                        </button>
                    </div>
                    <p className="mt-8 flex items-center gap-2 text-sm text-zinc-400">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
                        Currently deployed on major BESS, civil, and energy
                        projects across Australia.
                    </p>

                    <div className="mt-8 max-w-3xl space-y-4 text-[15px] sm:text-base text-zinc-400 leading-relaxed">
                        <p>
                            The category leaders built their platforms fifteen
                            to twenty-five years ago, before AI existed, and
                            are now bolting AI patches onto the side. Edara is
                            next generation:{" "}
                            <span className="text-white">AI-native from day one</span>
                            . Lean. Fast. Built for the AI era, not retrofitted
                            into it.
                        </p>
                        <p>
                            Edara is an Australian-built, AI-native compliance
                            and safety intelligence platform for Tier 1
                            construction, infrastructure and energy projects.
                            We unify workforce compliance, plant and equipment,
                            subcontractor management, site access control,
                            permits and incident management into a single
                            platform — with our flagship safety intelligence
                            module,{" "}
                            <span className="text-[#1FA8FF] font-semibold">
                                SENTINEL
                            </span>
                            , layered on top.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
